module.exports = __webpack_public_path__ + "static/img/haotemai.e5495bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/solution/case/haotemai.png
// module id = 8O04
// module chunks = 34